import { DailyStartVolume } from './daily_start_volume';
export class DailyStart {
    constructor(data, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nameWithNewLine", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "consecutiveRecordDays", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isCompletedToday", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "volumes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.name = data.name;
        this.nameWithNewLine = data.nameWithNewLine;
        this.description = data.description;
        this.consecutiveRecordDays = data.consecutiveRecordDays;
        this.isCompletedToday = data.isCompletedToday;
        this.volumes = data.volumes ? data.volumes.map((o) => new DailyStartVolume(o, config)) : [];
    }
}
